<template>

    <!-- 单选上传图片 -->

    <div class="m-img-upload" >

        <el-tooltip v-if="img.pic_id" :placement="placement" effect="light">
            <div slot="content">
              <el-image :src="img.url" fit="cover"  :style="{'width':width*1.5+'px','height':height*1.5+'px','line-height':height*1.5+'px','text-align':'center'}">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline" style="font-size:26px"></i>
                    </div>
                </el-image>
            </div>
            <div class="img-wrapper" :style="{'width':width+'px', 'height':height+'px'}">
              <el-image :src="img.url" fit="cover"  :style="{'width':width+'px','height':height+'px','line-height':height+'px','text-align':'center'}">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline" style="font-size:26px"></i>
                    </div>
                </el-image>
                <div class="img-edit" :style="{'width':width+'px', 'height':height+'px'}">
                    <i class="el-icon-delete" @click="handleRemove(img.pic_id)"></i>
                </div>
            </div>
        </el-tooltip>

        
      <label v-else  :style="{'width':width+'px', 'height':height+'px',}"  class="input-label" v-loading="loading">
        <i class="el-icon-plus upload-icon"></i>
        <input @change="handleChange($event)" type="file" accept=".jpg,jpeg,.png" style="display:none">
      </label>

    </div>
      
    

</template>

<script>
import { upload, imgDelete } from '@/untils/axios.js'

export default {
  name:"Upload",
  props:{
    fileName:{
      type:String,
      default:'',
      required:true,
    },
    width:{
      type:Number,
      default:80
    },
    height:{
      type:Number,
      default:80
    },
    placement: {
      type: String,
      default: 'top',
    },
    img: {
      type: Object,
      default: () => {},
      required: true
    },
    max:{
      type:Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods:{
    handleChange(e){
      let files = e.target.files
      var image = new FormData()
      image.append('filename', this.fileName)
      image.append('file', files[0])
      this.loading = true
      upload(image).then(res => {
        if(res){
          this.img    = res.data
          this.$emit('update:img', this.img)
        }
      }).finally( () => {
        this.loading = false
      })

    },

    handleRemove(id) {
      if(id != "") {
        imgDelete(id).then( res => {
          if(res) {
            this.img = {}
            this.$emit('update:img', this.img)
          }
        })
      }
    }

  },
}
</script>

<style lang="less" scoped>
.m-img-upload{
  display: inline-block;
    .img-wrapper {
      display: inline-block;
      position: relative;
      border-radius: 4px;
      margin-right:10px;
      &:hover {
          .img-edit {
              opacity: 1;
          }
      }
      img{ 
          object-fit: cover;
          border-radius: 4px;
          cursor: pointer;
      }
      .img-edit {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0,0,0,0.5);
          border-radius: 4px;
          opacity: 0;
          transition: opacity .3s;
          >i {
              font-size: 20px;
              color: #fff;
          }
      }
    }
  .input-label {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    text-align: center;
  }
  .input-label:hover{
    border-color:#409EFF ;
  }
  .upload-icon {
    font-size: 24px;
    color: #8c939d;
    position: relative;
    top: 50%; /*偏移*/
    transform: translateY(-50%);
  }
}
  
</style>